import { useSessionStorage } from "@vueuse/core";
import { useRoute } from "vue-router";

export const useAPI = () => {
  const config = useRuntimeConfig();
  const globalStore =
    typeof useState !== "undefined"
      ? useState("globalState", () => ({}))
      : { value: {} };
  const console = typeof useConsole !== "undefined" ? useConsole() : null;

  const reqStore =
    typeof useState !== "undefined"
      ? useState("reqState", () => [])
      : { value: [] };
  const log = (...args) => {
    if (console) {
      reqStore.value.push(...args);
      console.log(`🚀 RQST ${reqStore.value.length}:`, ...args);
    }
  };

  const logResp = (...args) => {
    if (console) console.log("👂 RESP:", ...args);
  };

  const fetch = async (endpoint, opts = {}) => {
    opts.query = opts.query || {};

    const reqStart = new Date().getTime();
    let resultResponse = {};

    opts.headers = opts.headers || {};
    opts.headers.Accept = "application/json";

    opts = Object.assign(
      {
        baseURL: config.public.apiEndpoint,
        ignoreResponseError: true,
        parseResponse: JSON.parse,

        onResponse({ request, options, response }) {
          resultResponse = response;
          logResp(endpoint, new Date().getTime() - reqStart, "ms");
        },
      },
      opts
    );

    const resultData = await $fetch(endpoint, opts);

    return {
      data: resultData,
      status: resultResponse.status,
    };
  };

  const createRequestUrl = (baseUrl) => {
    try {
      let url;
      const cookie = useSessionStorage("client_token");
      if (cookie.value) {
        url =
          baseUrl +
          (baseUrl.indexOf("?") !== -1 ? "&" : "?") +
          `embed_client_token=${cookie.value}`;
        return url;
      } else {
        const r = useRoute();
        if (r?.query.embed_client_token) {
          return (
            baseUrl +
            (baseUrl.indexOf("?") !== -1 ? "&" : "?") +
            `embed_client_token=${r?.query.embed_client_token}`
          );
        }
      }
      return baseUrl;
    } catch (error) {
      return baseUrl;
    }
  };

  const request = (endpoint, params, method) => {
    if (process.env.NODE_ENV === "development") {
      endpoint += (endpoint.indexOf("?") !== -1 ? "&" : "?") + "bypass=1";
    }

    log(`${method || "POST"} request to ${endpoint}`, params || []);

    return new Promise((success, failure) => {
      fetch(createRequestUrl(endpoint), {
        method: method || "GET",
        body: params || null,
      })
        .then((response) => {
          success(response);
        })
        .catch((errorResponse) => {
          const response = {
            error: true,
            response: errorResponse.response
              ? errorResponse.response._data
              : [],
          };
          success({ data: response });
        });
    });
  };

  return {
    request,
  };
};
